'use strict';

function FlightSummaryDataService(dataRetriever, dataTransformers) {
  function getData(screenState) {
    return dataRetriever.getFlightSummaryData(screenState);
  }
  function transformData(data, controlType) {
    return dataTransformers.transform(data, controlType);
  }
  function applyControlType(rows, controlType) {
    return dataTransformers.applyControlType(rows, controlType);
  }
  return {
    getData: getData,
    transformData: transformData,
    applyControlType: applyControlType
  };
}
FlightSummaryDataService.$inject = ['FlightManagementDataRetrieverService', 'FlightSummaryDataTransformerService'];
module.exports = FlightSummaryDataService;